import Vue from "vue";
import { getField, updateField } from "vuex-map-fields";
import { axiosCall } from "../../utils/axiosCall";

function initialState() {
  return {
    status: {
      business: "",
      countries: "",
      snapshots: "",
    },
    business: {}, // Complete info of the current business
    currentBusiness: {}, // Current business info for GET and UPDATE
    countries: {},
    snapshots: [],
    currentSnapshot: {},
  };
}

const state = initialState;

const getters = {
  getBusiness: (state) => state.business,
  getBusinessStatus: (state) => state.status.business,
  getCurrentBusiness: (state) => state.currentBusiness,
  getCountries: (state) => state.countries,
  getSnapshots: (state) => state.snapshots,
  getCurrentSnapshot: (state) => state.currentSnapshot || {},
  canUpdateSelfAssessment: (state, getters, rootState, rootGetters) => {
    let currentUserAccount = rootGetters.getUserAccountRoles.find(
      (accountRole) => accountRole.id
    );
    if (
      currentUserAccount &&
      currentUserAccount.name !== "Asesoría Externa ENEL" &&
      state.currentSnapshot &&
      state.currentSnapshot.status === "label_configuration_snapshot_active"
    ) {
      return true;
    } else {
      return false;
    }
  },
  getBusinessField: (state) => {
    return getField(state.business);
  },
  getField,
};

const actions = {
  BUSINESS_PREPARE: async ({ dispatch }) => {
    // Esta acción nos permite hacer las consultas a los endpoints y prepar toda la información
    // para ser renderizada.
    await dispatch("SNAPSHOTS_GET");
    await dispatch("BUSINESS_GET");
    await dispatch("SELF_ASSESSMENT_GET");
    await dispatch("OPTION_LIST_GET");
    await dispatch("COUNTRIES_GET");
    await dispatch("INVITATIONS_GET");
  },
  BUSINESS_GET: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit("setBusinessStatus", { status: "pending", key: "business" });
      if (!state.currentBusiness) {
        resolve(null);
      }
      axiosCall({ url: "Businesses/" + state.currentBusiness.id })
        .then((resp) => {
          commit("setBusinessStatus", { status: "success", key: "business" });
          commit("setBusiness", resp.data.business);
          resolve(resp);
        })
        .catch((err) => {
          commit("setBusinessStatus", { status: "error", key: "business" });
          reject(err);
        });
    });
  },
  BUSINESS_UPDATE: ({ commit, state }, data) => {
    commit("setBusinessStatus", { status: "pending", key: "business" });
    axiosCall({
      url: "Businesses/save/" + state.currentBusiness.id,
      method: "POST",
      data: data,
    }) // TODO Change name for id as url filter
      .then((resp) => {
        console.log(resp);
        commit("setBusinessStatus", { status: "success", key: "business" });
        // commit('BUSINESS_SUCCESS', resp.data[0])
      })
      .catch((err) => {
        console.log(err);
        commit("setBusinessStatus", { status: "error", key: "business" });
      });
  },
  SNAPSHOTS_GET: ({ commit, state }) => {
    commit("setBusinessStatus", { status: "pending", key: "snapshots" });
    return new Promise((resolve, reject) => {
      if (!state.currentBusiness) {
        resolve(null);
      }
      if (state.currentBusiness?.id) {
        axiosCall({ url: "Snapshots/list/" + state.currentBusiness.id })
          .then((resp) => {
            commit("setBusinessStatus", {
              status: "success",
              key: "snapshots",
            });
            commit("setSnapshots", resp.data.snapshots);
            resolve(resp);
          })
          .catch((err) => {
            commit("setBusinessStatus", { status: "error", key: "snapshots" });
            reject(err);
          });
      }
    });
  },
  COUNTRIES_GET: ({ commit, state }) => {
    if (state.status.countries !== "success") {
      return new Promise((resolve, reject) => {
        commit("setBusinessStatus", { status: "pending", key: "countries" });
        axiosCall({ url: "Countries" })
          .then((resp) => {
            commit("setBusinessStatus", {
              status: "success",
              key: "countries",
            });
            commit("setCountries", resp.data); // TODO Corregir con respecto al edpoint enviado por cristian, este no sirve porque me lista todas las empresas
            resolve(resp);
          })
          .catch((err) => {
            commit("setBusinessStatus", { status: "error", key: "countries" });
            reject(err);
          });
      });
    }
  },
};

const mutations = {
  setBusinessStatus: (state, data) => {
    state.status[data.key] = data.status;
  },
  setCurrentBusiness: (state, business) => {
    state.currentBusiness = business;
    Vue.set(state, "setReloadSelfAssessment", true);
  },
  updateCurrentSnapshot: (state, snapshotStatus) => {
    state.currentSnapshot.status = snapshotStatus;
  },
  setBusiness: (state, resp) => {
    Vue.set(state, "business", resp);
  },
  setSnapshots: (state, resp) => {
    Vue.set(state, "snapshots", resp);
    let tempCurrentSnapshot;
    if (resp && resp.length) {
      tempCurrentSnapshot = resp[0]; // Guardamos el primer snapshot en una variable temporal, para que no nos quede vacio
      for (var i in resp) {
        if (
          state.currentSnapshot &&
          resp[i].snapshotId === state.currentSnapshot.snapshotId
        ) {
          // Si el snapshot actual es igual a uno que viene de la consulta, nos salimos y no hacemos nada
          state.currentSnapshot = resp[i];
          return;
        }
        if (resp[i].status === "label_configuration_snapshot_active") {
          // Si hay alguno con la etiqueta de activo lo guardamos
          tempCurrentSnapshot = resp[i];
        }
      }
    }
    state.currentSnapshot = tempCurrentSnapshot; // Actualizamos el snapshot actual
  },
  setCountries: (state, resp) => {
    Vue.set(state, "countries", resp);
  },
  updateBusinessField: (state, field) => {
    updateField(state.business, field);
  },
  updateField,
  businessReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
